import React, { useState, useEffect } from 'react';
import storage from '../../higherOrder/storage';

import Header from '../HeaderShell';
import Notification from '../Notification/Notification.container';

const HeaderWithStorage = storage(Header, 'header', { isOpen: false });

const MainPage = (props) => {
    const [className, setClassName] = useState('page-wrapper page-wrapper-extended');

    useEffect(() => {
        setClassName(props.isNavExtended ? 'page-wrapper page-wrapper-extended' : 'page-wrapper');

        // Sync body and key sections classes with menu open state
        const bodySection = document.querySelector('body');
        const contentSection = document.querySelector('#page-wrapper .wrapper-content');
        const headSection = document.querySelector('#page-wrapper .page-heading');
        const notificationSection = document.querySelector('#page-wrapper .notification');
        const chartSection = document.querySelector('#page-wrapper .chart_container');
        const burger = document.querySelector('#page-wrapper .top-header__menu-toggle');

        const add = props.isNavExtended;
        if (bodySection) bodySection.classList.toggle('open-sidebar', add);
        if (contentSection) contentSection.classList.toggle('active-sidebar', add);
        if (headSection) headSection.classList.toggle('active-sidebar', add);
        if (notificationSection) notificationSection.classList.toggle('active-sidebar', add);
        if (chartSection) chartSection.classList.toggle('active-sidebar', add);
        if (burger) burger.classList.toggle('active', add);
    }, [props.isNavExtended]);

    return (
        <div className={className} id="page-wrapper">
            <HeaderWithStorage />
            <Notification />

            {props.children}
        </div>
    );
};

export default MainPage;
